declare namespace $ {

	type $shm_listener__shm_hitalama_app_1 = $mol_type_enforce<
		[ string, ReturnType< $shm_hitalama_app['command_palette_keydown_handler'] >, ReturnType< $shm_hitalama_app['document'] >, ({ 
			'passive': boolean,
		})  ]
		,
		ConstructorParameters< typeof $shm_listener >
	>
	type $shm_hitalama_map_command_palette__opened_shm_hitalama_app_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_app['command_palette_opened'] >
		,
		ReturnType< $shm_hitalama_map_command_palette['opened'] >
	>
	type $mol_check_icon__hint_shm_hitalama_app_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_icon['hint'] >
	>
	type $mol_check_icon__Icon_shm_hitalama_app_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_app['Process_monitor_toggle_icon'] >
		,
		ReturnType< $mol_check_icon['Icon'] >
	>
	type $mol_check_icon__checked_shm_hitalama_app_5 = $mol_type_enforce<
		ReturnType< $shm_hitalama_app['process_monitor_opened'] >
		,
		ReturnType< $mol_check_icon['checked'] >
	>
	type $shm_hitalama_mbutton__checked_shm_hitalama_app_6 = $mol_type_enforce<
		ReturnType< $shm_hitalama_app['chat_opened'] >
		,
		ReturnType< $shm_hitalama_mbutton['checked'] >
	>
	type $mol_view__sub_shm_hitalama_app_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_hitalama_app_fullscreen__map_book_shm_hitalama_app_8 = $mol_type_enforce<
		ReturnType< $shm_hitalama_app['Map'] >
		,
		ReturnType< $shm_hitalama_app_fullscreen['map_book'] >
	>
	type $shm_hitalama_app_fullscreen__overlay_panel_shm_hitalama_app_9 = $mol_type_enforce<
		ReturnType< $shm_hitalama_app['Overlay_panel'] >
		,
		ReturnType< $shm_hitalama_app_fullscreen['overlay_panel'] >
	>
	type $shm_hitalama_footer__version_shm_hitalama_app_10 = $mol_type_enforce<
		ReturnType< $shm_hitalama_app['version_data_version'] >
		,
		ReturnType< $shm_hitalama_footer['version'] >
	>
	type $shm_hitalama_footer__date_shm_hitalama_app_11 = $mol_type_enforce<
		ReturnType< $shm_hitalama_app['version_data_date'] >
		,
		ReturnType< $shm_hitalama_footer['date'] >
	>
	type __shm_hitalama_app_12 = $mol_type_enforce<
		Parameters< $shm_hitalama_app['Spread'] >[0]
		,
		Parameters< ReturnType< $shm_hitalama_app['Book'] >['Spread'] >[0]
	>
	type $mol_text__text_shm_hitalama_app_13 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_view__sub_shm_hitalama_app_14 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_page__head_shm_hitalama_app_15 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['head'] >
	>
	type $mol_page__body_shm_hitalama_app_16 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	type $shm_hitalama_vk_analysis__token_shm_hitalama_app_17 = $mol_type_enforce<
		ReturnType< $shm_hitalama_app['token'] >
		,
		ReturnType< $shm_hitalama_vk_analysis['token'] >
	>
	type $shm_hitalama_vk_lists__token_shm_hitalama_app_18 = $mol_type_enforce<
		ReturnType< $shm_hitalama_app['token'] >
		,
		ReturnType< $shm_hitalama_vk_lists['token'] >
	>
	type $shm_projects_catalog__projects_list_visible_shm_hitalama_app_19 = $mol_type_enforce<
		ReturnType< $shm_hitalama_app['projects_list_visible'] >
		,
		ReturnType< $shm_projects_catalog['projects_list_visible'] >
	>
	type $shm_hitalama_map_catalog__maps_list_visible_shm_hitalama_app_20 = $mol_type_enforce<
		ReturnType< $shm_hitalama_app['maps_list_visible'] >
		,
		ReturnType< $shm_hitalama_map_catalog['maps_list_visible'] >
	>
	type $shm_hitalama_profile_page__profiles_shm_hitalama_app_21 = $mol_type_enforce<
		ReturnType< $shm_hitalama_app['profiles'] >
		,
		ReturnType< $shm_hitalama_profile_page['profiles'] >
	>
	type $shm_hitalama_app_book__maps_list_visible_shm_hitalama_app_22 = $mol_type_enforce<
		ReturnType< $shm_hitalama_app['maps_list_visible'] >
		,
		ReturnType< $shm_hitalama_app_book['maps_list_visible'] >
	>
	type $shm_hitalama_app_book__projects_list_visible_shm_hitalama_app_23 = $mol_type_enforce<
		ReturnType< $shm_hitalama_app['projects_list_visible'] >
		,
		ReturnType< $shm_hitalama_app_book['projects_list_visible'] >
	>
	type $shm_hitalama_app_book__param_shm_hitalama_app_24 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_hitalama_app_book['param'] >
	>
	type $shm_hitalama_app_book__menu_title_shm_hitalama_app_25 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_hitalama_app_book['menu_title'] >
	>
	type $shm_hitalama_app_book__menu_tools_shm_hitalama_app_26 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_hitalama_app_book['menu_tools'] >
	>
	type $shm_hitalama_app_book__menu_foot_shm_hitalama_app_27 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_hitalama_app_book['menu_foot'] >
	>
	type $shm_hitalama_app_book__placeholders_shm_hitalama_app_28 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_hitalama_app_book['placeholders'] >
	>
	type $shm_hitalama_app_book__pages_shm_hitalama_app_29 = $mol_type_enforce<
		ReturnType< $shm_hitalama_app['book_pages'] >
		,
		ReturnType< $shm_hitalama_app_book['pages'] >
	>
	type $shm_hitalama_app_book__spreads_shm_hitalama_app_30 = $mol_type_enforce<
		({ 
			'': ReturnType< $shm_hitalama_app['Analysis'] >,
			'lists': ReturnType< $shm_hitalama_app['Lists'] >,
			'projects': ReturnType< $shm_hitalama_app['Projects'] >,
			'duckdb_page': ReturnType< $shm_hitalama_app['Duckdb'] >,
			'maps': ReturnType< $shm_hitalama_app['Maps'] >,
			'docs': ReturnType< $shm_hitalama_app['Docs'] >,
			'tasks': ReturnType< $shm_hitalama_app['Tasks'] >,
			'tests': ReturnType< $shm_hitalama_app['Tests'] >,
			'benchmarks': ReturnType< $shm_hitalama_app['Benchmarks'] >,
			'settings': ReturnType< $shm_hitalama_app['Settings'] >,
			'profile': ReturnType< $shm_hitalama_app['Profile_page'] >,
		}) 
		,
		ReturnType< $shm_hitalama_app_book['spreads'] >
	>
	type $shm_hitalama_entergate_internal__pending_login_shm_hitalama_app_31 = $mol_type_enforce<
		ReturnType< $shm_hitalama_app['entergate_pending_login'] >
		,
		ReturnType< $shm_hitalama_entergate_internal['pending_login'] >
	>
	type $shm_hitalama_profile_enter__profiles_shm_hitalama_app_32 = $mol_type_enforce<
		ReturnType< $shm_hitalama_app['profiles'] >
		,
		ReturnType< $shm_hitalama_profile_enter['profiles'] >
	>
	type $shm_hitalama_profile_register__profiles_shm_hitalama_app_33 = $mol_type_enforce<
		ReturnType< $shm_hitalama_app['profiles'] >
		,
		ReturnType< $shm_hitalama_profile_register['profiles'] >
	>
	type $shm_hitalama_opencode_map_chat__width_shm_hitalama_app_34 = $mol_type_enforce<
		ReturnType< $shm_hitalama_app['chat_width'] >
		,
		ReturnType< $shm_hitalama_opencode_map_chat['width'] >
	>
	type $shm_hitalama_project_codex__width_shm_hitalama_app_35 = $mol_type_enforce<
		ReturnType< $shm_hitalama_app['chat_width'] >
		,
		ReturnType< $shm_hitalama_project_codex['width'] >
	>
	export class $shm_hitalama_app extends $mol_view {
		Theme( ): $mol_theme_auto
		entergate_pending_auto( ): any
		mcp_client_auto( ): any
		side_views_auto( ): any
		selfhosted_tauri_admin_auto( ): any
		command_palette_keydown_handler( ): any
		document( ): any
		command_palette_keydown_listener( ): $shm_listener
		master_link( ): ReturnType< ReturnType< $shm_hitalama_app['Baza_status'] >['master_link'] >
		command_palette_opened( next?: boolean ): boolean
		Command_palette( ): $shm_hitalama_map_command_palette
		Process_monitor_toggle_icon( ): $mol_icon_clock_fast
		process_monitor_opened( next?: boolean ): boolean
		Process_monitor_toggle( ): $mol_check_icon
		Speech( ): $shm_hitalama_speech
		chat_opened( next?: boolean ): boolean
		Mbutton( ): $shm_hitalama_mbutton
		Right_bottom_panel( ): $mol_view
		Fullscreen( ): $shm_hitalama_app_fullscreen
		Overlay_panel( ): $shm_hitalama_app_overlay
		Status( ): $giper_baza_status
		Lights( ): $mol_lights_toggle
		version_data_version( ): string
		version_data_date( ): string
		Footer( ): $shm_hitalama_footer
		Book_menu( ): ReturnType< ReturnType< $shm_hitalama_app['Book'] >['Menu'] >
		spread( ): ReturnType< ReturnType< $shm_hitalama_app['Book'] >['spread'] >
		Spread( id: any): ReturnType< ReturnType< $shm_hitalama_app['Book'] >['Spread'] >
		Spread_default( ): ReturnType< ReturnType< $shm_hitalama_app['Book'] >['Spread_default'] >
		Tokens_label( ): $mol_text
		token( ): ReturnType< ReturnType< $shm_hitalama_app['Token_switch'] >['current'] >
		Token_switch( ): $shm_hitalama_vk_token_switch
		Tokens( ): $mol_view
		Profile( ): $shm_hitalama_profile_switch
		Spread_current( ): $mol_view
		Main( ): $mol_page
		side_views( ): readonly(any)[]
		book_pages( ): readonly(any)[]
		Analysis( ): $shm_hitalama_vk_analysis
		Lists( ): $shm_hitalama_vk_lists
		Projects( ): $shm_projects_catalog
		Duckdb( ): $shm_hitalama_duckdb_page
		Maps( ): $shm_hitalama_map_catalog
		Docs( ): $shm_hitalama_docs
		Tasks( ): $shm_hitalama_tasks
		Tests( ): $shm_tests_app
		Benchmarks( ): $shm_hitalama_benchmarks_catalog
		Settings( ): $shm_hitalama_settings
		Profile_page( ): $shm_hitalama_profile_page
		entergate_pending_login( next?: string ): string
		profiles( ): $shm_hitalama_profile_dict
		Domain_page( ): $shm_hitalama_domain_page
		title( ): string
		maps_list_visible( next?: boolean ): boolean
		projects_list_visible( next?: boolean ): boolean
		chat_width( next?: number ): number
		plugins( ): readonly(any)[]
		auto( ): readonly(any)[]
		Baza_status( ): $giper_baza_status
		sub( ): readonly(any)[]
		Book( ): $shm_hitalama_app_book
		Internal_register( ): $shm_hitalama_entergate_internal
		Enter( ): $shm_hitalama_profile_enter
		Register( ): $shm_hitalama_profile_register
		no_auth_pages( ): ({ 
			'domain_page': ReturnType< $shm_hitalama_app['Domain_page'] >,
		}) 
		Map( ): $shm_hitalama_map_book
		Ext( ): $shm_hitalama_extension_app
		Map_chat( ): $shm_hitalama_opencode_map_chat
		Project_chat( ): $shm_hitalama_project_codex
		Process_monitor( ): $shm_hitalama_process_monitor_maps
	}
	
}

//# sourceMappingURL=app.web.view.tree.d.ts.map